var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dgm_wrap padding_side mt105 mb90"},[_c('div',{staticClass:"register"},[_c('div',{staticClass:"login_title"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('loginText1'))}})]),_vm._m(0),_c('register-social-component')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login_top_img"},[_c('img',{attrs:{"src":require("@/assets/image/main_logo.png"),"alt":""}})])
}]

export { render, staticRenderFns }